import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/app.js";
import "./design-system/tokens.css";

const container = document.getElementById("root");
if (!container) throw new Error("the document has no #root to mount into");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
